import * as React from 'react';
import { useSelector } from 'react-redux';

import { MAP_CONTAINER_ID } from '../../constants/map';
import { offerSelector } from '../../selectors';
import { selectHasNewObject } from '../../selectors/newObject';
import { getDealType, isSale } from '../../utils/deal_type';
import { getOfferType, isFlat } from '../../utils/offer_type';
import { MapsSectionContainer } from '../MapsSectionContainer';
import { NewbuildingMapLoadable } from '../NewbuildingMapContainer';

export const OfferMapContainer = () => {
  const offer = useSelector(offerSelector);
  const hasNewObject = useSelector(selectHasNewObject);

  const isSaleOffer = React.useMemo(() => isSale(getDealType(offer)), [offer]);
  const isFlatOffer = React.useMemo(() => isFlat(getOfferType(offer)), [offer]);

  if (isSaleOffer && isFlatOffer && hasNewObject) {
    return (
      <div id={MAP_CONTAINER_ID}>
        <NewbuildingMapLoadable />
      </div>
    );
  }

  return <MapsSectionContainer />;
};
